<script setup lang="ts">
defineSlice({
  name: { label: 'Bento Nested Slices', group: 'Bento', layouts: ['VoixMarketing'] },
  description: '',
  preview: 'SlicesBentoNestedSlices.jpg',
  fields: {

  },
  templates: [{
    label: 'Main Example',
    fields: {

    },
  }],
})

const activated = inject('activated', false)
</script>

<template>
  <div class="w-full h-full pb-28 flex flex-col justify-center items-center space-y-2 -translate-x-6">
    <div class="rounded-md p-2 border flex justify-between items-center w-3/4 duration-500 ease-out" :class="{ 'text-neutral-500 border-neutral-800 translate-y-12': !activated, 'text-voix-stroke border-voix-stroke': activated }">
      <span>Bento Box</span>
      <div class="p-1 rounded border" :class="{ 'text-neutral-500 border-neutral-800': !activated, 'text-voix-stroke border-voix-stroke': activated }">
        <Icon name="heroicons:plus-20-solid" class="w-6 h-6" />
      </div>
    </div>
    <div
      class="ml-12 rounded-md p-2 border flex justify-between items-center w-3/4 text-voix-alt2 border-voix-alt2 duration-1000 delay-1000" :class="{ 'opacity-0 ': !activated }"
    >
      <span>Bento Box Card One</span>
      <div class="p-1 rounded border" :class="{ 'text-neutral-500 border-neutral-800': !activated, 'text-voix-alt2 border-voix-alt2': activated }">
        <Icon name="heroicons:plus-20-solid" class="w-6 h-6" />
      </div>
    </div>
    <div
      class="ml-12 rounded-md p-2 border flex justify-between items-center w-3/4 text-voix-alt2 border-voix-alt2 duration-1000 delay-[1.7s]" :class="{ 'opacity-0 ': !activated }"
    >
      <span>Bento Box Card Two</span>
      <div class="p-1 rounded border" :class="{ 'text-neutral-500 border-neutral-800': !activated, 'text-voix-alt2 border-voix-alt2': activated }">
        <Icon name="heroicons:plus-20-solid" class="w-6 h-6" />
      </div>
    </div>
  </div>
</template>
